import React from "react";
import { Helmet } from "react-helmet";

const BASE_URL = "https://maviinci.in";

function MetaTags({ data }) {
    if (!data) return null;

    const getAbsoluteUrl = (url) => {
        if (!url) return typeof window !== 'undefined' ? window.location.href : BASE_URL;
        if (url.startsWith("http")) return url;
        return `${BASE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
    };

    const absoluteUrl = getAbsoluteUrl(data.url);

    // Structured Data for Product/Article
    const structuredData = {
        "@context": "https://schema.org",
        "@type": data.type === "product" ? "Product" : "WebPage",
        "name": data.title,
        "description": data.description,
        "url": absoluteUrl,
        "image": data.image,
        "brand": {
            "@type": "Brand",
            "name": "Maviinci"
        },
        ...(data.price && {
            "offers": {
                "@type": "Offer",
                "price": data.price,
                "priceCurrency": "INR",
                "availability": "https://schema.org/InStock"
            }
        })
    };

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            {data.title && <title>{data.title}</title>}
            {data.description && <meta name="description" content={data.description} />}
            {data.keywords && <meta name="keywords" content={data.keywords} />}
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            
            {/* Open Graph / Facebook */}
            <meta property="og:type" content={data.type === "product" ? "product" : "website"} />
            {data.title && <meta property="og:title" content={data.title} />}
            {data.description && <meta property="og:description" content={data.description} />}
            {data.image && <meta property="og:image" content={data.image} />}
            <meta property="og:url" content={absoluteUrl} />
            <meta property="og:site_name" content="Maviinci" />
            <meta property="og:locale" content="en_IN" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            {data.title && <meta name="twitter:title" content={data.title} />}
            {data.description && <meta name="twitter:description" content={data.description} />}
            {data.image && <meta name="twitter:image" content={data.image} />}
            <meta name="twitter:site" content="@maviinci" />

            {/* Canonical URL */}
            <link rel="canonical" href={absoluteUrl} />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
}

export default MetaTags;
